import * as React from 'react';
import styled from 'styled-components';
import * as classNames from 'classnames';

interface IIconProps extends React.HTMLProps<HTMLElement> {
  size?: number;
}

export const Checkbox = ({ size = 21, className = '' }: IIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    className={`fill-current ${className}`}
  >
    <path d="M28 0h-24c-2.2 0-4 1.8-4 4v24c0 2.2 1.8 4 4 4h24c2.2 0 4-1.8 4-4v-24c0-2.2-1.8-4-4-4zM14 24.828l-7.414-7.414 2.828-2.828 4.586 4.586 9.586-9.586 2.828 2.828-12.414 12.414z" />
  </svg>
);

export const ListView = ({ size = 21, className = '' }: IIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    className={`fill-current ${className}`}
  >
    <path d="M12 2h20v4h-20v-4zM12 14h20v4h-20v-4zM12 26h20v4h-20v-4zM0 4c0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.209-1.791 4-4 4s-4-1.791-4-4zM0 16c0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.209-1.791 4-4 4s-4-1.791-4-4zM0 28c0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.209-1.791 4-4 4s-4-1.791-4-4z" />
  </svg>
);

export const TableView = ({ size = 21, className = '' }: IIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    className={`fill-current ${className}`}
  >
    <path d="M0 2v28h32v-28h-32zM12 20v-6h8v6h-8zM20 22v6h-8v-6h8zM20 6v6h-8v-6h8zM10 6v6h-8v-6h8zM2 14h8v6h-8v-6zM22 14h8v6h-8v-6zM22 12v-6h8v6h-8zM2 22h8v6h-8v-6zM22 28v-6h8v6h-8z" />
  </svg>
);

export const Stretch = ({ size = 21, className = '' }: IIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    className={`fill-current ${className}`}
  >
    <path d="M28.794 16.453l-4.785-4.842v3.396h-6.978v-11.007h-3v11.007h-6.978v-3.396l-4.847 4.842 4.823 4.863 0.024-3.352h6.978v11.036h3v-11.036h6.978l-0.039 3.352z" />
  </svg>
);

export const External = ({ size = 21, className = '' }: IIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 21 21"
    xmlns="http://www.w3.org/2000/svg"
    className={`fill-current ${className}`}
  >
    <path d="M11.935 2.642H2.758c-1.51 0-2.733 1.24-2.733 2.772v12.815C.025 19.759 1.248 21 2.758 21h12.637c1.509 0 2.732-1.24 2.732-2.771V8.923a.914.914 0 0 0-.906-.92.914.914 0 0 0-.907.92v9.306c0 .514-.412.93-.919.932H2.758a.928.928 0 0 1-.92-.932V5.414a.929.929 0 0 1 .92-.933h9.177c.5 0 .906-.412.906-.92a.913.913 0 0 0-.906-.92zM8.233 14.109l11.56-11.723a.932.932 0 0 0 0-1.302.898.898 0 0 0-1.281 0L6.952 12.807a.932.932 0 0 0 0 1.302.898.898 0 0 0 1.281 0zM15.34 2.144l3.784-.241-.237 3.838a.913.913 0 0 0 .849.975.91.91 0 0 0 .96-.86l.303-4.88a.935.935 0 0 0-.264-.707.899.899 0 0 0-.698-.267l-4.811.306a.915.915 0 0 0-.849.976.912.912 0 0 0 .963.86z" />
  </svg>
);

export const Calendar = ({ size = 25, className = '' }: IIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 28 28"
    xmlns="http://www.w3.org/2000/svg"
    className={`fill-current ${className}`}
  >
    <path d="M23.6 3.07h-2.276V1.478a.658.658 0 0 0-1.314 0V3.07h-3.228V1.478a.658.658 0 1 0-1.315 0V3.07h-3.228V1.478a.657.657 0 1 0-1.315 0V3.07H7.696V1.478a.657.657 0 1 0-1.314 0V3.07H.583v24.596h26.54V3.07H23.6zm2.206 23.282H1.9V4.385h4.482v1.393c0 .364.293.657.657.657a.655.655 0 0 0 .657-.657V4.385h3.228v1.393c0 .364.291.657.658.657a.655.655 0 0 0 .657-.657V4.385h3.228v1.393a.656.656 0 1 0 1.315 0V4.385h3.228v1.393a.656.656 0 1 0 1.315 0V4.385h4.481v21.967z" />
    <path d="M7.865 15.307h-1.64v1.643h1.64v-1.643zM7.877 19.786h-1.64v1.64h1.64v-1.64zM12.41 19.786h-1.642v1.64h1.641v-1.64zM16.938 19.786h-1.642v1.64h1.642v-1.64zM7.831 10.83H6.187v1.64h1.644v-1.64zM12.356 15.302h-1.641v1.643h1.641v-1.643zM16.885 15.302h-1.642v1.643h1.642v-1.643zM21.415 15.302h-1.643v1.643h1.643v-1.643zM12.318 10.82h-1.646v1.644h1.646V10.82zM16.846 10.82h-1.641v1.644h1.641V10.82zM21.375 10.82h-1.642v1.644h1.642V10.82z" />
  </svg>
);

export const Edit = ({ size = 30, className = '' }: IIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 36 36"
    xmlns="http://www.w3.org/2000/svg"
    className={`fill-current ${className}`}
  >
    <path d="M14.673 18.11l-.7 4.222 4.218-.7L31.8 8.131 28.28 4.61l-13.607 13.5zm-1.594 5.836a.702.702 0 0 1-.506-.214.739.739 0 0 1-.214-.642l.914-5.485a.857.857 0 0 1 .214-.39l14.172-14.18a.718.718 0 0 1 1.03 0l4.55 4.552a.72.72 0 0 1 0 1.03L19.065 22.819a.68.68 0 0 1-.389.195l-5.482.914h-.155" />
    <path d="M29.215 3.56l3.518 3.521 1.555-1.556a.525.525 0 0 0 .175-.39.564.564 0 0 0-.175-.408l-2.721-2.723a.583.583 0 0 0-.797 0L29.215 3.56zm3.518 5.291a.7.7 0 0 1-.525-.214L27.66 4.085a.719.719 0 0 1 0-1.03L29.74.972a2.04 2.04 0 0 1 2.858 0l2.722 2.723a1.944 1.944 0 0 1 .602 1.44 1.947 1.947 0 0 1-.602 1.42l-2.08 2.081a.66.66 0 0 1-.506.214zM18.56 23.051a.758.758 0 0 1-.524-.214l-4.55-4.571a.729.729 0 0 1 1.031-1.031l4.55 4.552a.739.739 0 0 1-.506 1.264z" />
    <path d="M28.378 35.579H3.864a3.07 3.07 0 0 1-3.072-3.074V7.917a3.074 3.074 0 0 1 3.072-3.073h14.035a.738.738 0 0 1 0 1.478H3.864A1.613 1.613 0 0 0 2.25 7.917v24.53a1.615 1.615 0 0 0 1.614 1.614h24.514a1.61 1.61 0 0 0 1.613-1.614V16.885a.72.72 0 0 1 .72-.74.738.738 0 0 1 .738.74v15.562a3.074 3.074 0 0 1-3.071 3.073" />
  </svg>
);

export const Search = ({ size = 20, className = '' }: IIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="-466.8 268.8 24.7 24.7"
    xmlns="http://www.w3.org/2000/svg"
    className={`fill-current ${className}`}
  >
    <path d="M-442.1 292.3l-5.3-5.3c1.7-1.9 2.7-4.4 2.7-7.2 0-6.1-4.9-11-11-11s-11 4.9-11 11 4.9 11 11 11c2.7 0 5.2-1 7.2-2.7l5.3 5.3 1.1-1.1zm-13.7-3.2c-2.6 0-4.9-1-6.6-2.7-1.7-1.7-2.7-4-2.7-6.6 0-2.6 1-4.9 2.7-6.6 1.7-1.7 4-2.7 6.6-2.7 2.6 0 4.9 1 6.6 2.7s2.7 4 2.7 6.6c0 2.6-1 4.9-2.7 6.6-1.7 1.7-4 2.7-6.6 2.7z" />
  </svg>
);

export const Trash = ({ size = 26, className = '' }: IIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="-466.3 268.2 23.3 24.1"
    xmlns="http://www.w3.org/2000/svg"
    className={`fill-current align-middle ${className}`}
  >
    <path d="M-444.1 271h-6.6l-.7-2.2c-.1-.4-.5-.7-1-.7h-5c-.5 0-.9.3-1 .7l-.6 2.1h-6.4c-.6 0-1 .5-1 1s.5 1 1 1h1.6l1.6 18.2c0 .5.5.9 1 .9h13.3c.5 0 1-.4 1-.9l1.1-18.2h1.7c.6 0 1-.5 1-1s-.4-.9-1-.9zm-12.5-.8h3.5l.3.9h-4l.2-.9zm7.8 20h-11.4l-1.5-17.1h13.9l-1 17.1z" />
    <path d="M-458.5 289c.6 0 1.1-.5 1.1-1.1v-12.4c0-.6-.5-1.1-1.1-1.1s-1.1.5-1.1 1.1v12.4c0 .6.5 1.1 1.1 1.1zM-454.5 289c.6 0 1.1-.5 1.1-1.1v-12.4c0-.6-.5-1.1-1.1-1.1s-1.1.5-1.1 1.1v12.4c0 .6.5 1.1 1.1 1.1zM-450.5 289c.6 0 1.1-.5 1.1-1.1v-12.4c0-.6-.5-1.1-1.1-1.1s-1.1.5-1.1 1.1v12.4c0 .6.5 1.1 1.1 1.1z" />
  </svg>
);

export const CaretDown = ({ size = 30, className = '' }: IIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="-461 274.1 36.4 12.9"
    xmlns="http://www.w3.org/2000/svg"
    className={`fill-current align-middle ${className}`}
  >
    <path d="M-442.1 287l-18.4-11c-.5-.3-.6-.9-.3-1.4.3-.5.9-.6 1.4-.3l17.3 10.4 16-10.4c.5-.3 1.1-.2 1.4.3s.2 1.1-.3 1.4l-17.1 11z" />
  </svg>
);

export const Copy = ({ size = 20, className = '' }: IIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className={`fill-current align-middle ${className}`}
  >
    <path d="M18.984 21v-14.016h-10.969v14.016h10.969zM18.984 5.016q0.797 0 1.406 0.586t0.609 1.383v14.016q0 0.797-0.609 1.406t-1.406 0.609h-10.969q-0.797 0-1.406-0.609t-0.609-1.406v-14.016q0-0.797 0.609-1.383t1.406-0.586h10.969zM15.984 0.984v2.016h-12v14.016h-1.969v-14.016q0-0.797 0.586-1.406t1.383-0.609h12z" />
  </svg>
);

export const QR = ({ size = 20, className = '' }: IIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 500 500"
    xmlns="http://www.w3.org/2000/svg"
    className={`fill-current align-middle ${className}`}
  >
    <path d="M327.5 76.3c-.2-.9-.6-1.9-.6-2.8V2.8c0-.9.1-1.7.2-2.8h38.2v38.3h35.3c1.2 0 2.4-.3 3.6-.4-.1 1.2-.3 2.4-.3 3.7v34.9h18.9V38h-18.6l-.3-25.5V.1h38.3v38.3h20l-.1-.1c-.2.4-.5.8-.5 1.2v37.1h38.3v77.2h-38.4v38.3H326.9V154c-1.2-.1-2-.2-2.7-.2h-72c-.8 0-1.5.2-2.3.3l.1.1v-38.7h-38.3V38.3h7.7l30.2-.3-.1-.1c.1 2 .4 4 .4 6v32.6c1.3.1 2.3.2 3.4.2H324c1.2 0 2.4-.3 3.5-.4-.2.9-.6 1.9-.6 2.9v33.9c0 .6.2 1.3.4 2.2h9.1l29.2.3v37.9h38.1v-38.2h-28.4c-3.2 0-6.5.2-9.7.4v-39h-34.5c-1.2 0-2.4-.2-3.6-.4zM249.6 345.6c.1-.8.3-1.5.3-2.3v-52.5c0-.6-.1-1.1-.1-2.1H76.9v-38.5c-1.5-.1-2.6-.2-3.7-.2H41.9c-1.1 0-2.1.3-3.2.5l.1.1c-.1-1.7-.4-3.3-.4-5v-33.9h76.8v38h38.5v-37.9H250v37.9h38.4v-37.9h57.9V250h34.9c1.3 0 2.6.4 3.9.6l-.1-.1v37.9h-96.3v57.7h-35c-1.6.1-2.9-.3-4.1-.5-.1 0 0 0 0 0zM327.1 500V327.2H500V500H327.1zm38.6-134.3v95.8h95.7v-95.8h-95.7zM.1 0h172.8v172.7H.1V0zm134.2 134.4V38.5H38.6v95.9h95.7zM.1 327.2h172.7v172.7H.1V327.2zm38.4 38.5v95.8h95.7v-95.8H38.5z" />
    <path d="M384.8 250.7v-38.9H500V250h-38.3v38.4h-38.4v-38.2c-1.6-.1-2.8-.2-4-.2H388c-1.1.1-2.2.4-3.2.7-.1-.1 0 0 0 0zM249.5 345.6c.1 2.6.4 5.1.4 7.7v31.4h38.2v76.9h-38.5l.1.1v-38.3h-38.1v-77c1.1-.1 2.3-.2 3.5-.2H246c1.2 0 2.4-.4 3.5-.6.1 0 0 0 0 0zM249.6 38c.1-5.6.3-11.2.3-16.8.1-6.9 0-13.9 0-21.1h38.2v38.2h-35c-1.1 0-2.4-.3-3.5-.3-.1-.1 0 0 0 0zM462.3 38.4c-.2-.4-.5-.8-.5-1.2V0h38.3v38.3h-37.8c-.1 0 0 .1 0 .1zM249.9 154.1v38h-38.2v-38c.5-.1 1.1-.3 1.7-.3H248c.7.1 1.3.3 1.9.3.1.1 0 0 0 0zM38.6 250.6c-.1 3.1-.3 6.2-.3 9.3v28.4H0v-37.9c.7-.1 1.4-.4 2.1-.4h33.6c1 .1 2 .4 2.9.6.1 0 0 0 0 0z" />
    <path d="M249.6 461.5l.3 31.9v6.5h-38.3v-38.3h38.1c0 .1-.1-.1-.1-.1zM384.8 385h57.5v57.2h-57.5V385zM57.6 115.1V57.8H115v57.3H57.6zM115 385v57.2H57.6V385H115z" />
  </svg>
);

interface ICircleIcon {
  size?: 'small' | 'big';
  color?: string;
  bgFill?: boolean;
  character?: string;
  className?: string;
}
interface IStyledCircle {
  color: string;
  bgFill: boolean;
}
const getColor = (color: string, theme: any) => {
  if (color.indexOf('#') === -1) {
    return theme[color];
  }
  return color;
};
const StyledCircle = styled.span<IStyledCircle>`
  background-color: ${(props) =>
    !props.bgFill ? 'transparent' : getColor(props.color, props.theme)};
  border-color: ${(props) => getColor(props.color, props.theme)};
  color: ${(props) =>
    props.bgFill ? '#fff' : getColor(props.color, props.theme)};
`;
export const Circle = ({
  size = 'big',
  color = '#fff',
  bgFill = false,
  character = 'i',
  className = '',
}: ICircleIcon) => (
  <StyledCircle
    color={color}
    bgFill={bgFill}
    className={classNames(
      'inline-block align-middle',
      'text-center leading-icon',
      'rounded-full border',
      {
        'w-7 h-7 text-lg': size === 'big',
        'w-5 h-5 text-sm': size !== 'big',
      },
      className
    )}
  >
    {character}
  </StyledCircle>
);

export const Info = (props: ICircleIcon) => <Circle {...props} />;
export const Warning = (props: ICircleIcon) => (
  <Circle
    character="!"
    color="#FDBC5A"
    bgFill={true}
    className="font-bold"
    {...props}
  />
);
export const Error = (props: ICircleIcon) => (
  <Circle
    character="!"
    color="#ed5d35"
    bgFill={true}
    className="font-bold"
    {...props}
  />
);
export const Success = (props: ICircleIcon) => (
  <Circle character="✔" color="#88C181" bgFill={true} {...props} />
);
export const Loading = (props: ICircleIcon) => (
  <Circle character="?" color="primary" bgFill={true} {...props} />
);



// WEBPACK FOOTER //
// ./src/components/Icons.tsx